export const relationEndpoints = (builder) => ({
    getRelationList: builder.query({
        query: (args = {}) => ({
            url: "/admin/relation-list",
            method: "GET",
            params: args,
        }),
        providesTags: ["Relation"],
    }),
});
